const TABLET = 768;

/**
 * Returns true if the device window is mobile size
 * @returns {boolean} Is mobile or not
 */
function isMobile() {
	return window.matchMedia(`(max-width:${TABLET - 1}px)`).matches;
}
